<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Fee Reconciliation Report </strong>
                </v-toolbar-title>
            </v-toolbar>
           <v-row justify="center" dense>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined persistent-hint
                        hint="Please Select Academic Year" />
                </v-col>
              <!-- Payment Type Dropdown -->
                <v-col cols="12" sm="2" md="2">
                    <v-icon style="visibility: hidden;">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded return-object
                        v-model="payment_type" :items="payment_type_list" item-text="type"
                        label="Payment Type" outlined hide-details />
                </v-col>

                <!-- Payment Gateway Dropdown (Visible only for All and Online) -->
                <v-col cols="12" sm="2" md="2" v-if="payment_type && payment_type.type !== 'Offline'">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="gateway" :items="gateway_list"
                        item-text="name" item-value="id" label="Payment Gateway" outlined persistent-hint
                        hint="Please Select Payment Gateway" />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-select rounded required v-model="section" :items="section_list" item-text="name" dense
                        item-value="id" outlined multiple persistent-hint hint="Please select section" @change="getStd()">
                        <template #label>Section</template>
                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="selected_all_section" @change="toggle_section()">
                                        <template #label><span class="ml-8">Select All</span></template>
                                    </v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-select>
                </v-col>

                <!-- Standard Dropdown -->
                <v-col cols="12" sm="3" md="3" v-if="section && std_div_list.length > 0">
                    <v-icon color="error">*</v-icon>
                    <v-select rounded required v-model="sel_std_data" :items="std_div_list" item-text="standard" dense
                        item-value="id" outlined multiple persistent-hint hint="Please select standard">
                        <template #label>Standard</template>
                        <template v-slot:prepend-item>
                            <v-list-item @mousedown.prevent>
                                <v-list-item-action>
                                    <v-checkbox v-model="selected_all_standard" @change="toggle_standard()">
                                        <template #label><span class="ml-8">Select All</span></template>
                                    </v-checkbox>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                    </v-select>
                </v-col>
            </v-row>

            <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3">
                    <p><b>From Date</b><v-icon small class="pb-2 pl-1" color="error">*</v-icon></p>
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field dense v-model="selected_date" v-bind="attrs" v-on="on" prepend-icon="event"
                                hint="This Date Is Inclusive" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <p><b>To Date</b><v-icon small class="pb-2 pl-1" color="error">*</v-icon></p>
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field dense v-model="to_date" v-on="on" v-bind="attrs" prepend-icon="event"
                                hint="This Date Is Exclusive" persistent-hint></v-text-field>
                        </template>
                        <v-date-picker v-model="todate" no-title @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <!-- Gateway is only required when Payment Type is NOT Offline -->
                <v-col cols="12" sm="2" md="2" class="pt-8 pl-2" align="center"
                    v-if="sel_ay_data && section.length > 0 && sel_std_data.length > 0 && (payment_type && payment_type.type === 'Offline' || gateway)">
                    <v-btn color="primary" @click="fetchReconciliationReport()"> Fetch </v-btn>
                </v-col>
               
            </v-row>
            <br>
            <div id="my-table-id">
                <v-data-table v-if="arrayList.length" :items="bookList1" :items-per-page="-1" dense
                    class="elevation-1 table-class" fixed-header hide-default-header>
                    <template v-slot:top>
                        <v-row justify="center" align="center" class="pb-2">
                            <v-col cols="12">
                                <v-row dense align="center">
                                    <span v-for="header in headers" :key="header.value">
                                        <v-autocomplete v-if="filters.hasOwnProperty(header.value)" class="mr-2" flat
                                            hide-details small rounded dense outlined :label="header.text" multiple
                                            clearable :items="columnValueList(header.value)"
                                            v-model="filters[header.value]" />
                                    </span>

                                    <v-btn class="ma-2 no-display" rounded color="success" outlined
                                        @click="fnExcelReport('my-table-id', 'reconciliationReport')">
                                        <v-icon color="success">
                                            mdi-export
                                        </v-icon>
                                        Export
                                    </v-btn>
                                </v-row>
                            </v-col>
                        </v-row>
                    </template>

                    <template v-slot:header>
                        <tr>
                            <th v-for="header in headers" :key="'header-' + header.value" rowspan="2"
                                class="custom-header fixed-column-header">
                                {{ header.text }}
                            </th>
                            <th v-for="category in fee_component_headers" :key="'category-' + category.category_id"
                                :colspan="category.components.length" class="custom-header category-header">
                                {{ category.category_name }}
                            </th>
                            <th rowspan="2" class="custom-header fixed-column-header">Outstanding</th>
                        </tr>
                        <tr>
                            <template v-for="category in fee_component_headers">
                                <th v-for="component in category.components" :key="'component-' + component.id"
                                    class="custom-header component-header">
                                    {{ component.name }}
                                </th>
                            </template>
                        </tr>
                    </template>
                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="fixed-body-cell">
                                {{ item.srno }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.roll_no }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.studentname }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.category }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.quota }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.standard }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.division }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.payment_mode }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.paymenttype }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.creation_date }}
                            </td>
                            <td class="fixed-body-cell">
                                {{ item.settlement_date }}
                            </td>
                            <td class="amount-cell">
                                {{ Number(item.fee_receivable || 0).toFixed(2) }}
                            </td>
                            <td class="amount-cell">
                                {{ Number(item.fee_received || 0).toFixed(2) }}
                            </td>
                            <template v-for="category in fee_component_headers">
                                <td v-for="component in category.components" :key="item.srno + '-' + component.id"
                                    class="amount-cell component-cell">
                                    {{
                                        Number(
                                            (item.fee_components || {})[component.id.toString()] || 0
                                        ).toFixed(2)
                                    }}
                                </td>
                            </template>
                            <td class="amount-cell">
                                {{ Number(item.total_outstanding || 0).toFixed(2) }}
                            </td>
                        </tr>
                    </template>
                    <template v-slot:body.append>
                        <tr class="total-row">
                            <td :colspan="fixedColumnsBeforeAmount" class="total-cell total-label">
                                <strong>Total</strong>
                            </td>
                            <td class="total-cell amount-cell">
                                <strong>
                                    {{ totalReceivable }}
                                </strong>
                            </td>
                            <td class="total-cell amount-cell">
                                <strong>
                                    {{ totalReceived }}
                                </strong>
                            </td>
                            <template v-for="category in fee_component_headers">
                                <td v-for="component in category.components" :key="'total-' + component.id"
                                    class="total-cell amount-cell">
                                    <strong>
                                        {{ Number(componentTotals[component.id] || 0).toFixed(2) }}
                                    </strong>
                                </td>
                            </template>
                            <td class="total-cell amount-cell">
                                <strong>
                                    {{ totalOutstanding }}
                                </strong>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
import { stream } from "xlsx";
export default {
    components: {
        Breadcrumbs,
    },

    data() {
        return {
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            std_div_list: [],
            sel_std_data: [],
            overlay: false,
            stream: null,
            category: null,
            arrayList: [],
            filterArr: [],
            gateway_list: [],
            gateway: null,
            to_date: "",
            date: new Date().toISOString().substr(0, 10),
            menu1: false,
            menu2: false,
            todate: new Date().toISOString().substr(0, 10),
            nowDate: new Date().toISOString().slice(0, 10),
            section_list: [],
            section: [],
            fee_component_headers: [],
            selected_all_standard: false,
            selected_all_section: false,
            payment_type: { id: 1, type: "All" },
            payment_type_list: [
                { id: 1, type: "All" },
                { id: 2, type: "Online" },
                { id: 3, type: "Offline" },
            ],
            filters: {
                // order_id: [],
                // transaction_id: [],
                // studentname: [],
                // request_transaction_date: [],
                // settlement_date: [],
            },
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Roll No.", value: "roll_no" },
                { text: "Student Name", value: "studentname" },
                { text: "Category", value: "category" },
                { text: "Admission Type (NEW/RTE/Regular)", value: "quota" },
                { text: "Standard", value: "standard" },
                { text: "Division", value: "division" },
                { text: "Payment Mode", value: "payment_mode" },
                { text: "Payment Type", value: "paymenttype" },
                { text: "Transaction Date", value: "creation_date" },
                { text: "Settlement Date", value: "settlement_date" },
                { text: "Fee Receivable", value: "fee_receivable" },
                { text: "Total Received", value: "fee_received" },
               
            ],
        };
    },
    computed: {
        bookList1() {
            return this.arrayList.filter((d) => {
                const mode = d.payment_mode ? d.payment_mode.toString().trim() : "";
                const pType = this.payment_type.type || "All";

                if (pType === "Online") {
                    if (mode.toLowerCase() !== "online") return false;
                } else if (pType === "Offline") {
                    if (!mode || mode === "-" || mode.toLowerCase() === "online") return false;
                }

                return Object.keys(this.filters).every((f) => {
                    return (
                        !this.filters[f] ||
                        this.filters[f].length < 1 ||
                        this.filters[f].includes(d[f])
                    );
                });
            });
        },

        totalReceivable() {
            return this.bookList1.reduce((sum, item) => sum + (parseFloat(item.fee_receivable) || 0), 0).toFixed(2);
        },

        totalReceived() {
            return this.bookList1
                .reduce(
                    (sum, item) =>
                        sum + (parseFloat(item.fee_received) || 0),
                    0
                )
                .toFixed(2);
        },

        totalOutstanding() {
            return this.bookList1
                .reduce(
                    (sum, item) =>
                        sum + (parseFloat(item.total_outstanding) || 0),
                    0
                )
                .toFixed(2);
        },

        componentTotals() {
            const totals = {};

            this.fee_component_headers.forEach(category => {
                category.components.forEach(component => {
                    totals[component.id] = this.bookList1.reduce((sum, item) => {

                        const feeComponents = item.fee_components || {};

                        return (
                            sum +
                            (parseFloat(
                                feeComponents[component.id.toString()]
                            ) || 0)
                        );

                    }, 0);
                });
            });
            return totals;
        },
        fixedColumnsBeforeAmount() {
            return this.headers.findIndex(
                h => h.value === "fee_receivable"
            );
        },
    },

    methods: {
        getFiltered(e) {
            this.filterArr = e;
        },
        columnValueList(val) {
            return this.arrayList.map((d) => d[val]);
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },          
        async fetchReconciliationReport() {
    this.overlay = true;
   const isOffline = this.payment_type && this.payment_type.type === "Offline";
    const data = {
        ay: this.sel_ay_data.ay_id,
        gateway: isOffline ? null : this.gateway,
        date: this.selected_date,
        todate: this.to_date,
        standard: this.sel_std_data,
        payment_type: this.selected_payment_type
    };
    try {
        const res = await axios.post("/AccountingAndFeesReports/fetchFeeReconciliationReport", data);
        if (res.data.flag == "YES") {
            this.arrayList = res.data.arrayList || [];
            this.fee_component_headers = res.data.fee_component_headers || [];
            if (this.arrayList.length == 0) {
                this.showSnackbar("#b71c1c", "No Data Found....");
            }
        } else {
            this.showSnackbar("#b71c1c", "Something went wrong...");
        }
    } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong...");
    } finally {
        this.overlay = false;
    }
},
        toggle_standard() {
            this.$nextTick().then(() => {
                if (this.selected_all_standard) {
                    this.sel_std_data = [];
                    for (var x in this.std_div_list) {
                        this.sel_std_data.push(this.std_div_list[x].id);
                    }
                } else {
                    this.sel_std_data = [];
                }
            });
        },
        toggle_section() {
            this.$nextTick().then(() => {
                if (this.selected_all_section) {
                    this.section = [];
                    for (var x in this.section_list) {
                        this.section.push(this.section_list[x].id);
                    }
                    this.getStd();
                } else {
                    this.section = [];
                }
            });
        },
        onload() {
            axios
                .post("/commonAPI/get_ay_std_div")
                .then((res) => {
                    console.log(res.data);
                    this.ay_std_div_list = res.data.data;
                    this.gateway_list = res.data.gateway_list;
                    this.sel_ay_data = res.data.sel_ay_data;
                    this.section_list = res.data.section_std_list;
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                })
                .finally(() => { });
        },
        getStd() {
            this.selected_all_standard = false;

            if (!this.section || this.section.length === 0) {
                this.std_div_list = [];
                this.sel_std_data = [];
                return;
            }
            let stdList = [];

            this.section.forEach(sectionId => {

                let section = this.section_list.find(
                    item => item.id === sectionId
                );

                if (section && section.section_std_list) {
                    stdList = stdList.concat(section.section_std_list);
                }
            });

            this.std_div_list = stdList;

            if (this.std_div_list.length === 0) {
                alert("No standard found!!!");
                this.sel_std_data = [];
            }
        },
        fnExcelReport(id, name) {
            let tab_text = `<table border='1px'>`;
            tab_text += `
            <tr>
                <th rowspan="2">SR. No.</th>
                <th rowspan="2">Roll No.</th>
                <th rowspan="2">Student Name</th>
                <th rowspan="2">Category</th>
                <th rowspan="2">Quota</th>
                <th rowspan="2">Standard</th>
                <th rowspan="2">Division</th>
                <th rowspan="2">Payment Mode</th>
                <th rowspan="2">Payment Type</th>
                <th rowspan="2">Creation Date</th>
                <th rowspan="2">Settlement Date</th>
                <th rowspan="2">Fee Receivable</th>
                <th rowspan="2">Total Received</th>
            `;
            this.fee_component_headers.forEach(category => {
                tab_text += `
                <th colspan="${category.components.length}">
                    ${category.category_name}
                </th>
            `;
            });
            tab_text += `<th rowspan="2">Outstanding</th>`;
            tab_text += `</tr>`;
            tab_text += `<tr>`;

            this.fee_component_headers.forEach(category => {
                category.components.forEach(component => {
                    tab_text += `
                <th>${component.name}</th>
            `;
                });
            });

            tab_text += `</tr>`;

            let totalReceivable = 0;
            let totalReceived = 0;
            let totalOutstanding = 0;

            let componentTotals = {};

            this.fee_component_headers.forEach(category => {
                category.components.forEach(component => {
                    componentTotals[component.id] = 0;
                });
            });
            this.bookList1.forEach((item, index) => {
                totalReceivable += Number(item.fee_receivable || 0);
                totalReceived += Number(item.fee_received || 0);
                totalOutstanding += Number(item.total_outstanding || 0);
                tab_text += `
                    <tr>
                        <td>${index + 1}</td>
                        <td>${item.roll_no || '-'}</td>
                        <td>${item.studentname || '-'}</td>
                        <td>${item.category || '-'}</td>
                        <td>${item.quota || '-'}</td>
                        <td>${item.standard || '-'}</td>
                        <td>${item.division || '-'}</td>
                        <td>${item.payment_mode || '-'}</td>
                        <td>${item.paymenttype || '-'}</td>
                        <td>${item.creation_date || '-'}</td>
                        <td>${item.settlement_date || '-'}</td>

                        <td>${Number(item.fee_receivable || 0).toFixed(2)}</td>
                        <td>${Number(item.fee_received || 0).toFixed(2)}</td>
                `;
                this.fee_component_headers.forEach(category => {
                    category.components.forEach(component => {
                        let value = Number(
                            (item.fee_components || {})[component.id.toString()] || 0
                        );
                        componentTotals[component.id] =
                            (componentTotals[component.id] || 0) + value;

                        tab_text += `
                    <td>${value.toFixed(2)}</td>
                `;
                    });

                });
                tab_text += `
                    <td>${Number(item.total_outstanding || 0).toFixed(2)}</td>
                `;
                tab_text += `</tr>`;
            });
            let fixedColumnCount = 10;
            tab_text += `
                <tr>
                    <td colspan="${fixedColumnCount}" align="right">
                        <b>Total</b>
                    </td>

                    <td>
                        <b>${totalReceivable.toFixed(2)}</b>
                    </td>

                    <td>
                        <b>${totalReceived.toFixed(2)}</b>
                    </td>
                `;

                this.fee_component_headers.forEach(category => {

                    category.components.forEach(component => {

                        tab_text += `
                        <td>
                            <b>${Number(componentTotals[component.id] || 0).toFixed(2)}</b>
                        </td>
                    `;
                    });

                });
                tab_text += `
                    <td>
                        <b>${totalOutstanding.toFixed(2)}</b>
                    </td>
                `;
                tab_text += `
                    </tr>
                `;

            tab_text += `</table>`;

            const blob = new Blob(
                [tab_text],
                {
                    type: "application/vnd.ms-excel"
                }
            );

            const filename =
                name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                    blob,
                    filename
                );

            } else {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }
        },
    },
    mounted() {
        this.onload();
        this.selected_date = this.formatDate(this.date);
        this.to_date = this.formatDate(this.todate);
    },
   watch: {
        payment_type: {
            handler(val) {
                if (val && val.type === "Offline") {
                    this.gateway = null;
                }
            },
            deep: true
        },
        date(val) {
            this.selected_date = this.formatDate(this.date);
        },
        todate(val) {
            this.to_date = this.formatDate(this.todate);
        },
    },
};
</script>
<style scoped>
.table-class {
    width: 100%;
}

.table-class>>>table {
    width: max-content !important;
    min-width: 100% !important;
    border-collapse: collapse !important;
}

.table-class>>>th.custom-header {
    font-weight: 700 !important;
    text-align: center !important;
    white-space: nowrap !important;
    border: 1px solid #d0d0d0 !important;
    padding: 8px 12px !important;
    vertical-align: middle !important;
    background-color: mediumpurple;
    color: white;
}

.table-class>>>th.fixed-column-header {
    min-width: 100px !important;
}

.table-class>>>th.category-header {
    font-size: 14px !important;
    padding: 8px 12px !important;
}

.table-class>>>th.component-header {
    font-size: 13px !important;
    min-width: 110px !important;
    padding: 8px 12px !important;
}

.table-class>>>td {
    white-space: nowrap !important;
    border: 1px solid #e0e0e0 !important;
    padding: 6px 10px !important;
}

.table-class>>>.amount-cell {
    text-align: right !important;
    white-space: nowrap !important;
}

.table-class>>>.component-cell {
    min-width: 110px !important;
}

.table-class>>>.total-row .total-cell {
    height: 56px !important;
    padding: 12px 16px !important;
    font-size: 15px !important;
    background: #f5f5f5 !important;
    border-top: 2px solid #999 !important;
}

.table-class>>>.total-label {
    text-align: right !important;
}
</style>
